













import {
  defineComponent,
  onMounted,
  reactive,
  toRefs
} from '@vue/composition-api'
import AppSearch from './search/index.vue'
import AppList from './list/index.vue'
import { SelectModule } from '@/store/modules/select'
import $http from '@/api'

export default defineComponent({
  name: 'AppDetail',
  components: { AppSearch, AppList },
  setup() {
    const state = reactive({
      filterData: {
        page: 1,
        count: 10000,
        queryContent: '',
        category: 0,
        clientType: 0,
        userType: 0
      },
      listData: [],
      loaded: false
    })
    const appSearch = async () => {
      const { filterData } = state
      state.loaded = false
      const res: any = await $http.searchApps(filterData)
      const apps = res.data || {}
      state.loaded = true
      state.listData =
        Array.isArray(apps.list) && apps.list.length ? apps.list : []
    }
    onMounted(() => {
      state.filterData.category = SelectModule.query
      appSearch()
    })
    return { ...toRefs(state), appSearch }
  }
})
